import { css } from '@emotion/react';

import { COLORS2, LAYOUT2, TYPOGRAPHY2 } from '@/Client/Styles';
import { ProgressBar } from '@/Client/Widgets/ProgressBar';

const CONTAINER_STYLE = css`
  label: LABELED_PROGRESS_BAR_CONTAINER_STYLE;
  display: flex;
  flex-direction: column;
  gap: ${LAYOUT2.spacingHalf}px;
  width: 100%;
`;

const HEADING_STYLE = css`
  label: LABELED_PROGRESS_BAR_HEADING_STYLE;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
`;

const LABEL_ROW_STYLE = css`
  label: LABELED_PROGRESS_BAR_LABEL_ROW_STYLE;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: ${LAYOUT2.spacingHalf}px;
`;

const MAIN_LABEL_STYLE = css`
  label: LABELED_PROGRESS_BAR_MAIN_LABEL_STYLE;
  ${TYPOGRAPHY2.medium}
  color: ${COLORS2.namedColors.charcoal};
`;

const SECONDARY_LABEL_STYLE = css`
  label: LABELED_PROGRESS_BAR_SECONDARY_LABEL_STYLE;
  ${TYPOGRAPHY2.xSmall}
  color: ${COLORS2.namedColors.darkestGray};
`;

const VALUE_ROW_STYLE = css`
  label: LABELED_PROGRESS_BAR_VALUE_ROW_STYLE;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const VALUE_LABEL_STYLE = css`
  label: LABELED_PROGRESS_BAR_VALUE_LABEL_STYLE;
  ${TYPOGRAPHY2.smallBold}
  color: ${COLORS2.namedColors.darkestGray};
`;

export const LabeledProgressBar = ({
  label,
  headingExplanation,
  rightLabel,
  value,
  max,
  valueLabel,
  maxLabel,
  filledColor,
  emptyColor,
}: {
  label: string;
  headingExplanation?: string;
  rightLabel?: string;
  value: number;
  max: number;
  valueLabel?: string;
  maxLabel?: string;
  filledColor: string;
  emptyColor: string;
}) => (
  <div css={CONTAINER_STYLE}>
    <div css={HEADING_STYLE}>
      <div css={LABEL_ROW_STYLE}>
        <span css={MAIN_LABEL_STYLE}>{label}</span>
        {headingExplanation && <span css={SECONDARY_LABEL_STYLE}>{headingExplanation}</span>}
      </div>
      {rightLabel && <span css={SECONDARY_LABEL_STYLE}>{rightLabel}</span>}
    </div>
    <ProgressBar progress={max > 0 ? Math.min(value / max, 1) : 0} filledColor={filledColor} emptyColor={emptyColor} />
    <div css={VALUE_ROW_STYLE}>
      <span css={VALUE_LABEL_STYLE}>{valueLabel}</span>
      <span css={VALUE_LABEL_STYLE}>{maxLabel}</span>
    </div>
  </div>
);
